import { Heading } from 'blaze-ui/Heading/Heading'
import { FormInputProps } from 'screens/Campaigns/components/AddCampaignModal/CreateCampaign/Types'
import { useField } from 'formik'
import { Input } from 'almanac-ui/TextInputField/Input'
import Styles from './CreateCampaign.module.scss'
import { Text } from 'blaze-ui/Text/Text'

export const TargetLinkInput = ({ name }: FormInputProps) => {
  const [field, meta, helpers] = useField<string>(name)
  return (
    <label className={Styles.label}>
      <div className={Styles.description}>
        <Heading level={4}>Enter target link</Heading>
        <Text variant="secondary" color="var(--dark-40)">
          Campaigns will drive traffic to your target link via Call-to-Action link.
          <br />
          By default, we will direct traffic to your website.
        </Text>
      </div>
      <Input
        name={name}
        placeholder="Enter a target link"
        value={field.value}
        onChange={async (e) => {
          await helpers.setValue(e.target.value)
        }}
        isValid={!meta.touched || !meta.error}
        errorMessage={meta.touched && meta.error}
      />
    </label>
  )
}
